import React, { useLayoutEffect, useRef } from 'react';
import styles from './VideoBlock.module.scss';
import clsx from 'clsx';

const VideoBlock = (props) => {
  const {
    width,
    height,
    cloudName,
    sourceJs,
    sourceUrl,
    position = 'center',
    showVideoControls,
    videoId = 'videoPlayer',
  } = props;

  const containerRef = useRef(null);

  if (!cloudName || !sourceUrl) {
    return;
  }

  useLayoutEffect(() => {
    if (containerRef.current) {
      const videoElement = document.createElement('video');
      videoElement.id = videoId;
      videoElement.className = 'cld-video-player cld-video-player-skin-dark';
      videoElement.width = width || '100%';
      videoElement.height = height;
      videoElement.style.width = width || '100%';
      containerRef.current.replaceChildren(videoElement);

      if (videoElement) {
        const player = window.cloudinary?.videoPlayer(videoElement, {
          playsinline: true,
          cloud_name: cloudName,
          muted: true,
          autoplay: !showVideoControls,
          loop: !showVideoControls,
          controls: showVideoControls,
        });
        player?.source(sourceUrl, JSON.parse(sourceJs));
      }
    }
  }, [containerRef]);

  return (
    <div
      ref={containerRef}
      className={clsx(styles.videoBlock, styles[`position_${position}`])}
    />
  );
};

export default VideoBlock;
